"use client"

import { useState } from "react"
import { Pencil, FileText } from "lucide-react"
import { EditProfileModal } from "./edit-profile-modal"
import { UpdateGradesModal } from "./update-gardes-modal"

interface StudentHeroProps {
  name: string
  studentId: string
  class: string
  house: string
  careerPath: string
  status: "active" | "inactive" | "suspended"
  enrolledSubjects: string[]
}

export function StudentHero({
  name,
  studentId,
  class: studentClass,
  house,
  careerPath,
  status,
  enrolledSubjects,
}: StudentHeroProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [isGradesModalOpen, setIsGradesModalOpen] = useState(false)

  const statusConfig = {
    active: { label: "ACTIVE", bg: "bg-emerald-500", text: "text-white" },
    inactive: { label: "INACTIVE", bg: "bg-gray-400", text: "text-white" },
    suspended: { label: "SUSPENDED", bg: "bg-red-500", text: "text-white" },
  }

  return (
    <>
      <section className="bg-white rounded-xl p-5 shadow-sm border border-gray-200 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-teal-50 rounded-full -mr-10 -mt-10 opacity-50 z-0"></div>

        <div className="relative z-10 flex flex-col lg:flex-row gap-6 justify-between items-start lg:items-center">
          <div className="flex flex-col md:flex-row gap-5 items-start md:items-center w-full lg:w-auto">
            <div className="relative shrink-0">
              <div
                className="bg-center bg-no-repeat bg-cover rounded-full h-20 w-20 ring-2 ring-teal-500 ring-offset-2"
                // style={{
                //   backgroundImage: `url("https://api.dicebear.com/7.x/avataaars/svg?seed=${name}")`,
                // }}
              ></div>
              <div
                className={`absolute bottom-0 right-0 ${statusConfig[status].bg} ${statusConfig[status].text} text-[9px] font-bold px-1.5 py-0.5 rounded-full border border-white`}
              >
                {statusConfig[status].label}
              </div>
            </div>

            <div className="flex flex-col gap-1.5">
              <div>
                <h1 className="text-2xl font-bold text-gray-900 leading-none">{name}</h1>
                <p className="text-sm text-gray-500 mt-1 font-medium">
                  Class: {studentClass} ({house}) <span className="mx-1.5 opacity-30">|</span> ID: {studentId}
                </p>
              </div>

              <div className="flex items-center gap-2">
                <span className="bg-gray-900 text-white text-xs px-2 py-0.5 rounded flex items-center gap-1 font-medium">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                  {careerPath}
                </span>
              </div>
            </div>
          </div>

          <div className="flex gap-2 w-full lg:w-auto mt-2 lg:mt-0">
            <button
              onClick={() => setIsEditModalOpen(true)}
              className="flex-1 lg:flex-none flex items-center justify-center gap-1.5 px-3 py-2 bg-white border border-gray-200 hover:border-teal-500 text-gray-900 text-xs font-bold rounded-lg transition-all hover:bg-teal-50"
            >
              <Pencil className="w-4 h-4" />
              Profile
            </button>
            <button
              onClick={() => setIsGradesModalOpen(true)}
              className="flex-1 lg:flex-none flex items-center justify-center gap-1.5 px-3 py-2 bg-white border border-gray-200 hover:border-teal-500 text-gray-900 text-xs font-bold rounded-lg transition-all hover:bg-teal-50"
            >
              <FileText className="w-4 h-4" />
              Grades
            </button>
          </div>
        </div>
      </section>

      <EditProfileModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        student={{ name, studentId, class: studentClass, house, careerPath, status }}
      />
      <UpdateGradesModal
        isOpen={isGradesModalOpen}
        onClose={() => setIsGradesModalOpen(false)}
        studentName={name}
        studentId={studentId}
      />
    </>
  )
}
